import React from 'react';
import styled from 'styled-components';

import { TicketType } from '../../TicketType';

function getNumberOfAddedTicketsByType(tickets, type) {
    return tickets.reduce(
        (carry, ticket) => carry + (
            ticket.type === type
                ? 1
                : 0
        ),
        0,
    );
}

function TicketTypesList({
    ticketTypes,
    addedTickets,
    selectedTicketType,
    disabled,
    onSelectTicketType,
}) {
    return (
        <Wrapper className="ticket-types-list">
            {ticketTypes.map(type => {
                return (
                    <TicketType
                        key={type.name}
                        type={type.name}
                        count={getNumberOfAddedTicketsByType(
                            addedTickets,
                            type.name,
                        )}
                        locked={!addedTickets.length && type.locked || disabled}
                        onClick={onSelectTicketType}
                        selected={selectedTicketType === type.name}
                    />
                );
            })}
        </Wrapper>
    );
}

export { TicketTypesList };

const Wrapper = styled.div`
    display: flex;
    flex-wrap: wrap;

    .ticket-type + .ticket-type {
        margin-left: 16px;
    }
`;
